import './App.css';
import { Alert, Box, Button, Card, CardContent, FormControl, FormHelperText, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField, Typography } from '@mui/material'
import { useState, useEffect } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { CheckCircle, Visibility, VisibilityOff } from '@mui/icons-material';
import localAuthServices from './localAuthServices';
import AuthServices from './services/auth';
import { Link } from "react-router-dom";
import 'antd/dist/antd.min.css';

function App() {

  const [showPassword, setShowPassword] = useState();
  const [alertType, setAlertType] = useState();
  const [apiMessage, setApiMessage] = useState();
  const [token, setToken] = useState();
  const [refreshToken, setRefreshToken] = useState();

  var query = window.location.search.substring(1);
  var vars = query.split("&");
  var pair1 = vars[0].split("=");
  var pair2 = vars[1].split("=");
  const [sourceDomain] = useState(pair1[1]);
  const [existingToken] = useState(pair2[1]);

  let validLogin = false;
  if (localAuthServices.isLoggedIn()) {
    if (localAuthServices.getToken() === existingToken) {
      validLogin = true;
    }
  }
  const [loggedIn, setLoggedIn] = useState(validLogin);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const closeWindow = () => {
    if (token == null || refreshToken == null) {
      setToken(localAuthServices.getToken())
      setRefreshToken(localAuthServices.getRefreshToken())
    }

    AuthServices.getUserData({}, apiData => {
      if (apiData.status) {
        window.opener.postMessage({
          event_id: "sso_token",
          token: token,
          refresh_token: refreshToken,
          user: apiData.data
        }, sourceDomain);
        setTimeout(function () {
          window.self.close();
        }, 2000);
      }
    })
  }

  useEffect(() => {
    localAuthServices.removeToken()
  },[])

  return (
    <div className="App">
      <Box>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
          style={{ minHeight: '100vh' }}
        >
          <Grid item xs={3}>
            <Card>
              {!loggedIn ?
                <CardContent sx={{ textAlign: "center" }}>
                  <Grid
                    container
                    spacing={0}
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    style={{ minHeight: '100%' }}
                    className='overlap'
                  >
                    <Grid item xs={12} md={6} className='logoContainer'>
                      <img src='/logo_black.png' alt="iCapital" className='logo' />
                    </Grid>
                    <Grid item xs={11} md={6} className='displayBoxBorder'>
                      <Typography style={{ textAlign: 'left', fontSize: '30px' }}>
                        <b style={{ color: '#EC1C24' }}>HELLO</b>
                      </Typography>
                      <Typography style={{ textAlign: 'left', whiteSpace: 'pre-line', fontSize: '13px'}}>
                        {'Log in to your Capital Dynamics account here.\nThis is a ONE-TIME registration process. You may reuse the same login credentials when you register for our future events.\n\nTo our '}<i>i</i>{' Capital subscribers, please note that the login credentials for '}
                        <a href="https://www.icapital.biz/" target="_blank">www.icapital.biz</a>
                        {' is NOT usable on this platform. You will need to register a new account.\n\nIf you are an existing iPortal ('}
                        <a href="https://iportal.capitaldynamics.com.au/" target="_blank">https://iportal.capitaldynamics.com.au/</a>
                        {') user, you may log in using your existing credentials.'}
                      </Typography>
                      <Formik
                        initialValues={{
                          username: '',
                          password: ''
                        }}
                        validationSchema={Yup.object().shape({
                          username: Yup.string().max(50).required('Username or email is required'),
                          password: Yup.string().max(50).required('Password is required')
                        })}
                        onSubmit={async (data) => {
                          let _data = data;
                          if (sourceDomain === 'http://localhost:3003' || sourceDomain === 'https://uat-events.icapital.biz') {
                            _data['service'] = 2
                          } else if (sourceDomain === 'https://events.icapital.biz'){
                            _data['service'] = 3
                          }
                          try {
                            var response = await AuthServices.login(_data);
                            setToken(response.data.access);
                            setRefreshToken(response.data.refresh);
                            localAuthServices.setLogin(response.data.access, response.data.refresh);
                            localStorage.setItem('toRefresh', true);
                            localAuthServices.setTokenExpiration();
                            setLoggedIn(true)
                          } catch (e) {
                            setAlertType('error')
                            setApiMessage(e.response.data.message)
                          }
                        }}
                      >
                        {({
                          errors,
                          handleBlur,
                          handleChange,
                          handleSubmit,
                          isSubmitting,
                          touched
                        }) => (
                          <form onSubmit={handleSubmit}>
                            <TextField
                              error={Boolean(touched.username && errors.username)}
                              fullWidth
                              helperText={touched.username && errors.username}
                              label={'Your username or email'}
                              margin="normal"
                              name="username"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              type="text"
                              variant="outlined"
                            />
                            <FormControl
                              fullWidth
                              margin="normal"
                              variant="outlined"
                            >
                              <InputLabel
                                className={(touched.password && errors.password) ? "Mui-error" : ""}
                                htmlFor="outlined-adornment-password"
                              >
                                {'Your password'}
                              </InputLabel>
                              <OutlinedInput
                                error={Boolean(touched.password && errors.password)}
                                id="outlined-adornment-password"
                                type={showPassword ? 'text' : 'password'}
                                name="password"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={handleClickShowPassword}
                                      onMouseDown={handleMouseDownPassword}
                                      edge="end"
                                      size="large">
                                      {showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                  </InputAdornment>
                                }
                                aria-describedby="password-helper-text"
                                label="Your Password"
                              />
                              {(touched.password && errors.password) && <FormHelperText
                                className={(touched.password && errors.password) ? "Mui-error" : ""}
                                id="password-helper-text"
                              >
                                {'Password is required'}
                              </FormHelperText>}
                            </FormControl>
                            {apiMessage &&
                              <Box mb={3} sx={{ marginTop: "10px" }}>
                                <Alert severity={alertType}>{apiMessage}</Alert>
                              </Box>
                            }
                            <Box my={2}>
                              <Button
                                color="primary"
                                disabled={isSubmitting}
                                fullWidth
                                size="large"
                                type="submit"
                                variant="contained"
                                id="login_button"
                              >
                                {'login'}
                              </Button>
                            </Box>
                            <Box mt={2.5}>
                              <Typography
                                color="textSecondary"
                                variant="body1"
                                align="center"
                              >
                                {'Don’t have an account?'}
                                {' '}
                                <Link
                                  to={"/register?" + query}
                                  color="secondary"
                                  underline=
                                  "none"
                                >
                                  {'Register'}
                                </Link>
                                {' '}
                                {'here'}
                              </Typography>
                              <Typography
                                color="textSecondary"
                                variant="body1"
                                align="center"
                              >
                                {'Forgot your password?'}
                                {' '}
                                <Link
                                  to={"/forgot-password?" + query}
                                  color="secondary"
                                  underline="none"
                                >
                                  {'Click here'}
                                </Link>
                                {' '}
                                {'to reset password'}
                              </Typography>
                            </Box>
                          </form>
                        )}
                      </Formik>
                    </Grid>
                  </Grid>
                </CardContent>
                :
                <CardContent sx={{ textAlign: "center" }} className="login_success">
                  <Grid
                    container
                    spacing={0}
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    style={{ minHeight: '100vh' }}
                  >
                    <Grid item xs={6} className='displayBoxBorder'>
                      <CheckCircle color='success' sx={{ fontSize: "100px", marginBottom: "30px" }} />
                      <Typography>
                        You are now logged in to your Capital Dynamics account.
                        <br />
                        This window will close in a few seconds.
                      </Typography>
                    </Grid>
                    <Grid item xs={6} className='logoContainer'>
                      <img src='/logo.png' alt="iCapital" width="50%" height="auto" />
                    </Grid>
                    {closeWindow()}
                  </Grid>
                </CardContent>
              }
            </Card>
          </Grid>
        </Grid>
      </Box>
    </div >
  );
}

export default App;
